<template>
  <b-modal
    :active.sync="showModal"
    trap-focus
    aria-role="dialog"
    aria-modal
    has-modal-card
    @close="closeModal"
  >
    <div class="modal-card" style="width: 700px" v-if="entry">
      <header class="modal-card-head">
        <p class="modal-card-title">Copy Event</p>
      </header>
      <section class="modal-card-body">
        <div>
          <ValidationObserver ref="observer" v-slot="{ passes }">
            <form @submit.prevent="passes(submit)">
              <BaseInput
                v-model="entry.eventname"
                label="New Event Name"
                rules="required"
                @blur="setUrl"
              />
              <BaseInput v-model="entry.url" label="New URL" rules="required" />
              <BaseDateTimePicker
                v-model="entry.eventdate"
                label="Start Date"
                rules="required"
              />
              <BaseDateTimePicker
                v-model="entry.eventenddate"
                label="End Date"
                rules="required"
              />
              <div class="has-margin-top-10">
                <button class="button" type="button" @click="closeModal">
                  Close
                </button>
                <button
                  class="button is-primary has-margin-left-5"
                  type="submit"
                  @click.prevent="passes(submit)"
                >
                  Create
                </button>
              </div>
            </form>
          </ValidationObserver>
        </div>
      </section>
    </div>
  </b-modal>
</template>

<script>
import EventApi from '@/api/event'
import BaseDateTimePicker from '@/components/BaseDateTimePicker'
import EventBus from '@/eventbus'

export default {
  name: 'UpdateGymNameModal',
  components: {
    BaseDateTimePicker,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    event: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      showModal: this.show,
      entry: null,
    }
  },
  watch: {
    show() {
      this.showModal = this.show
    },
  },
  created() {
    this.entry = {
      _id: this.event._id,
      eventname: `${this.event.eventname} Copy`,
      url: ``,
      eventdate: new Date(),
      eventenddate: new Date(),
    }
  },
  methods: {
    setUrl() {
      if (
        this.entry.eventname.trim() != '' &&
        (!this.entry.url || this.entry?.url.trim() === '')
      ) {
        this.entry.url = this.generateSlug(this.entry.eventname)
      }
    },
    generateSlug(text) {
      return text
        .toString()
        .toLowerCase()
        .trim()
        .replace(/[\s\W-]+/g, '-')
        .replace(/^-+|-+$/g, '') // Remove leading and trailing hyphens
    },
    async submit() {
      await EventApi.copy(this.entry)
      this.showModal = false
      this.$emit('close-modal')
      EventBus.$emit('refresh-events')
      this.$buefy.toast.open({
        message: 'Event copied successfully.',
        position: 'is-top',
        type: 'is-success',
      })
    },
    closeModal() {
      this.showModal = false
      this.$emit('close-modal')
    },
  },
}
</script>
